export default __webpack_public_path__ + "static/media/checkbox-checked.cef252d6.svg";